import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import { useQuery } from 'components/graphql'
import { Row, Col } from 'react-flexbox-grid'
import { Select, Number as NumberInput } from 'components/forms'
import { multiValidate, notEmpty, notNegative, minMaxFields, minMaxVal } from 'helpers/validators'
import appConfig from 'gql/query/appConfig/'
import Divider from 'components/Divider'
import { StyledSubLabel, StyledNoMarginWrapper } from './StyledComponents'

const TradePrices = ({ mode }) => {
	const [t] = useTranslation()

	const getValidation = (relatedField, ind) => {
		const validate = (val, vals) => {
			const relatedVal = get(vals, ['tradePrice', ind, relatedField])
			if(relatedVal) {
				return notEmpty().validate(val)
			}
			return
		}
		const notify = [`tradePrice[${ind}].${relatedField}`]
		return { validate, notify, validateOnChange: true }
	}

	const tradePrices = []
	for (let i = 0; i < 5; i++) {
		const item = (
			<Col key={i} xs className='narrow-col'>
				<StyledSubLabel className='form-group-label' isVisible={!i}>
					{t('common.fields.quantity')}
				</StyledSubLabel>
				<NumberInput
					field={`tradePrice[${i}].count`}
					placeholder={`Menge ${i + 1}`}
					{...getValidation('price', i)}
					{...i === 0 && notEmpty()}
					withControls={false}
					shrink />
				<StyledSubLabel className='form-group-label' isVisible={!i}>
					{mode === 0 ? t('product_section.strings.sum') : t('product_section.strings.price')}
				</StyledSubLabel>
				<NumberInput
					field={`tradePrice[${i}].price`}
					placeholder={`Preis ${i + 1}`}
					format='currency'
					{...getValidation('count', i)}
					{...i === 0 && multiValidate([notEmpty(), notNegative()])}
					withControls={false}
					shrink
					toFixed={2}
					precision={2} />
			</Col>
		)
		tradePrices.push(item)
	}

	return <Row>{tradePrices}</Row>
}

const TradePriceDetails = ({ mode }) => {
	const [t] = useTranslation()
	const { data, queryField } = useQuery(appConfig.actionGroups)
	const getActionGroupOptions = () => get(data, [queryField, 'productActionGroups'])
		?.map((item, i) => ({ value: i + 1, label: item })) || []
	const emptyValidation = notEmpty()

	return(
		<Fragment>
			<Row>
				<Col xs>
					<Select
						field='mode'
						label={t('product_section.strings.mode')}
						options={[
							{ value: 0, label: 'Mengenangebot Stück' },
							{ value: 2, label: 'Mengenangebot Aktion "3 für 2"' },
							{ value: 3, label: 'Mengenangebot 100% Rabatt für das günstigste Stück' },
							{ value: 4, label: 'Mengenangebot Preis ab Menge' }
						]} />
				</Col>
				<Col xs>
					{(mode === 3) &&
						<Select
							field='actionGroup'
							options={getActionGroupOptions()}
							label={t('product_section.strings.group')}
							placeholder='Gruppe auswählen'
							{...mode === 3 && { ...notEmpty(), validateOnChange: true }} />
					}
					{mode === 1 &&
						<NumberInput
							field='actionDiscount'
							label={`${t('product_section.strings.discount')}, %`}
							{...multiValidate([notEmpty(), minMaxVal({ max: 100 })])}
							withControls={false} />
					}
					{mode === 2 &&
						<StyledNoMarginWrapper>
							<NumberInput
								field='actionAmount.more'
								label={`${t('common.fields.quantity')} 3`}
								{...multiValidate([notEmpty(), notNegative(), minMaxFields('max', 'actionAmount.less')])}
								withControls={false}
								shrink
								inline />
							<NumberInput
								field='actionAmount.less'
								label={`${t('common.fields.quantity')} 2`}
								{...multiValidate([notEmpty(), notNegative(), minMaxFields('min', 'actionAmount.more')])}
								withControls={false}
								shrink
								inline />
						</StyledNoMarginWrapper>
					}
				</Col>
				<Col xs>
					{mode === 3 &&
						<NumberInput
							field='tradePrice[0].count'
							label={t('product_section.strings.amount_from')}
							validate={val => emptyValidation.validate(val) || (val < 2 ? 'Value must be greater 1' : null)}
							withControls={false} />
					}
				</Col>
			</Row>
			{(mode === 0 || mode === 4) &&
				<Fragment>
					<Divider />
					<p className='form-group-label'>{t('product_section.strings.price_offer')}</p>
					<TradePrices mode={mode} />
				</Fragment>
			}
		</Fragment>
	)
}

export default TradePriceDetails
